import { Industry } from '__generated__/Industry';
import IndustryField from 'projects/components/BriefFields/IndustryField';
import OtherField from 'projects/components/BriefFields/OtherField';
import ProfileApprovalField from 'projects/components/BriefFields/ProfileApprovalField';
import UrlsField from 'projects/components/BriefFields/UrlsField';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import * as React from 'react';

interface Fields {
    industry: string;
    urls: string[];
    profileApproval: boolean;
    other: string;
}

export interface Props<T> {
    form: ObservableForm<T>;
    industries: Industry[];
    brief: { id: string };
}

class AboutYouPage<T extends Fields> extends React.Component<Props<T>> {
    componentDidMount() {
        trackViewedBriefEvent({
            id: this.props.brief.id,
            page: 'AboutYou',
        });
    }

    render() {
        const { form, industries } = this.props;

        return (
            <div className="content-setting">
                <IndustryField form={form} industries={industries} />
                <UrlsField form={form} />
                <ProfileApprovalField form={form} />
                <OtherField form={form} />
            </div>
        );
    }
}

export default AboutYouPage;
